import React from 'react';

const Portfolio = () => {
    const mockData = {
        predictions: [
            { id: 1, description: 'Prediction 1', status: 'active', amount: 100 },
            { id: 2, description: 'Prediction 2', status: 'resolved', amount: 200 }
        ],
        balance: 1500,
        profitLoss: 300
    };

    return (
        <div>
            <h1>User Portfolio</h1>
            <h2>Balance: ${mockData.balance}</h2>
            <h2>Profit/Loss: ${mockData.profitLoss}</h2>
            <h3>Predictions</h3>
            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {mockData.predictions.map(prediction => (
                        <tr key={prediction.id}>
                            <td>{prediction.id}</td>
                            <td>{prediction.description}</td>
                            <td>{prediction.status}</td>
                            <td>${prediction.amount}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Portfolio;